import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useListPortalTranslationsQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/TranslationsRpc.hooks';
import { getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
import { useIsUngated } from './useIsUngated';
import { PREFERRED_LANGUAGE_GATE } from '../constants/gates';
export const DEFAULT_SUB_KEY = '_default';
export function usePortalTranslations(locale, options) {
  const isPreferredLanguageEnabled = useIsUngated(PREFERRED_LANGUAGE_GATE);
  const _useListPortalTransla = useListPortalTranslationsQuery({
      variables: Object.assign({
        accountId: getPortalAccountId(),
        portalInstanceId: getPortalInstanceId(),
        tolerateInstanceAccessDenied: true
      }, locale && {
        locale
      }),
      skip: (options === null || options === void 0 ? void 0 : options.skip) || !isPreferredLanguageEnabled
    }),
    {
      data
    } = _useListPortalTransla,
    rest = _objectWithoutPropertiesLoose(_useListPortalTransla, _excluded);
  const portalText = (key, subKey) => {
    var _data$translations;
    if (!isPreferredLanguageEnabled) {
      return undefined;
    }
    const resolvedSubKey = subKey !== null && subKey !== void 0 ? subKey : DEFAULT_SUB_KEY;
    return data === null || data === void 0 || (_data$translations = data.translations) === null || _data$translations === void 0 || (_data$translations = _data$translations.find(entry => {
      var _entry$subKey;
      return entry.key === key && ((_entry$subKey = entry.subKey) !== null && _entry$subKey !== void 0 ? _entry$subKey : DEFAULT_SUB_KEY) === resolvedSubKey;
    })) === null || _data$translations === void 0 ? void 0 : _data$translations.value;
  };
  return Object.assign({
    portalText,
    data
  }, rest);
}